var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "enterprise_box", on: { click: _vm.toAuth } }, [
      _c("div", { staticClass: "left_content" }, [
        _vm._m(0),
        _c(
          "ul",
          { staticClass: "contract_data" },
          [
            _vm.allAuthUser.bindCorpUsers &&
            !_vm.allAuthUser.bindCorpUsers.length &&
            _vm.allAuthUser &&
            !_vm.isInDingTalk
              ? _c("li", { staticClass: "contract_data_li" }, [
                  _vm._m(1),
                  _vm._m(2)
                ])
              : _vm._e(),
            _vm.authUser.identityAuth > -1
              ? _vm._l(_vm.allAuthUser.notBindCorpUsers, function(item, index) {
                  return _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.isInDingTalk ||
                            (_vm.isInDingTalk && item.userStemFrom === -16),
                          expression:
                            "!isInDingTalk || (isInDingTalk && item.userStemFrom === -16)"
                        }
                      ],
                      key: index,
                      staticClass: "contract_data_li"
                    },
                    [
                      _c("div", { staticClass: "join_tip" }, [
                        _vm._v("待加入")
                      ]),
                      _c("div", { staticClass: "title flex_title" }, [
                        _c("div", [
                          _c("span", { staticClass: "block" }),
                          item.userStemFrom === -16 && !_vm.isInDingTalk
                            ? _c("img", {
                                attrs: {
                                  src: "/images/icon/dingIcon.png",
                                  alt: "钉钉",
                                  width: "20px"
                                }
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n                  " +
                              _vm._s(item.corpName || " ") +
                              "\n                "
                          )
                        ])
                      ]),
                      _vm._m(3, true)
                    ]
                  )
                })
              : _vm._e(),
            _vm.authUser.identityAuth > -1
              ? _vm._l(_vm.allAuthUser.bindCorpUsers, function(item, index) {
                  return _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (_vm.isInDingTalk &&
                              _vm.dingInfo.jzqCorpId === item.corpId) ||
                            !_vm.isInDingTalk,
                          expression:
                            "(isInDingTalk && dingInfo.jzqCorpId === item.corpId) || !isInDingTalk"
                        }
                      ],
                      key: index,
                      staticClass: "contract_data_li"
                    },
                    [
                      _c("div", { staticClass: "join_tip" }, [
                        _vm._v("加入的")
                      ]),
                      _c("div", { staticClass: "title flex_title" }, [
                        _c("div", [
                          _c("span", { staticClass: "block" }),
                          item.userStemFrom === -16 && !_vm.isInDingTalk
                            ? _c("img", {
                                attrs: {
                                  src: "/images/icon/dingIcon.png",
                                  alt: "钉钉",
                                  width: "20px"
                                }
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n                  " +
                              _vm._s(item.corpName || " ") +
                              "\n                "
                          )
                        ]),
                        _vm.isInDingTalk
                          ? _c("span", { staticClass: "title_console" }, [
                              _c("i", {
                                staticClass: "el-icon-setting recharge_icon"
                              }),
                              _vm._v(
                                "\n                  企业控制台\n                "
                              )
                            ])
                          : _c("span")
                      ]),
                      _c("div", { staticClass: "li_content" }, [
                        _c("div", { staticClass: "li_once" }, [
                          _vm._m(4, true),
                          _c("div", { staticClass: "li_text" }, [
                            _c("p", { staticClass: "p" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.corpInfo.signCount[item.corpUserId]
                                      ? _vm.signNumberFn([
                                          _vm.corpInfo.signCount[
                                            item.corpUserId
                                          ].noFinishCount,
                                          _vm.corpInfo.signCount[
                                            item.corpUserId
                                          ].myApplyNotSelfSignCount,
                                          _vm.corpInfo.signCount[
                                            item.corpUserId
                                          ].ccToMeSignCount
                                        ])
                                      : 0
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _c("span", [_vm._v("待签署")])
                          ])
                        ]),
                        _c("div", { staticClass: "li_once" }, [
                          _vm._m(5, true),
                          _c("div", { staticClass: "li_text" }, [
                            _c("p", { staticClass: "p" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.corpInfo.signCount[item.corpUserId]
                                    ? _vm.signNumberFn([_vm.statistics(item)])
                                    : 0
                                )
                              )
                            ]),
                            _c("span", [_vm._v("待审批")])
                          ])
                        ]),
                        _c("div", { staticClass: "li_once" }, [
                          _vm._m(6, true),
                          _c("div", { staticClass: "li_text" }, [
                            _c("p", { staticClass: "p" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.corpInfo.signCount[item.corpUserId]
                                      ? _vm.signNumberFn([
                                          _vm.corpInfo.signCount[
                                            item.corpUserId
                                          ].myFinishCount,
                                          _vm.corpInfo.signCount[
                                            item.corpUserId
                                          ].ccToMeFinishCount,
                                          _vm.corpInfo.signCount[
                                            item.corpUserId
                                          ].selfSignFinishCount
                                        ])
                                      : ""
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _c("span", [_vm._v("已结束")])
                          ])
                        ])
                      ])
                    ]
                  )
                })
              : _vm._l(_vm.allAuthUser.bindCorpUsers, function(item, index) {
                  return _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (_vm.isInDingTalk &&
                              _vm.dingInfo.jzqCorpId === item.corpId) ||
                            !_vm.isInDingTalk,
                          expression:
                            "(isInDingTalk && dingInfo.jzqCorpId === item.corpId) || !isInDingTalk"
                        }
                      ],
                      key: index,
                      staticClass: "contract_data_li"
                    },
                    [
                      _c("div", { staticClass: "join_tip" }, [
                        _vm._v("加入的")
                      ]),
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "block" }),
                        item.userStemFrom === -16 && !_vm.isInDingTalk
                          ? _c("img", {
                              attrs: {
                                src: "/images/icon/dingIcon.png",
                                alt: "钉钉",
                                width: "20px"
                              }
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n                " +
                            _vm._s(item.corpName || " ") +
                            "\n              "
                        )
                      ]),
                      _vm._m(7, true)
                    ]
                  )
                }),
            _c("li", { staticClass: "contract_data_li" }, [
              _c("p", { staticClass: "title" }, [
                _c("span", { staticClass: "block" }),
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.getUserName) +
                    "\n            "
                )
              ]),
              _c("div", { staticClass: "li_content" }, [
                _c("div", { staticClass: "li_once" }, [
                  _vm._m(8),
                  _c("div", { staticClass: "li_text" }, [
                    _c("p", { staticClass: "p" }, [
                      _vm._v(
                        _vm._s(
                          _vm.signNumberFn([
                            _vm.signCount.noFinishCount,
                            _vm.signCount.myApplyNotSelfSignCount,
                            _vm.signCount.ccToMeSignCount
                          ])
                        )
                      )
                    ]),
                    _c("span", [_vm._v("待签署")])
                  ])
                ]),
                _c("div", { staticClass: "li_once" }, [
                  _vm._m(9),
                  _c("div", { staticClass: "li_text" }, [
                    _c("p", { staticClass: "p" }, [
                      _vm._v(
                        _vm._s(
                          _vm.signNumberFn([
                            _vm.signCount.finishCount,
                            _vm.signCount.myFinishCount
                          ])
                        )
                      )
                    ]),
                    _c("span", [_vm._v("已结束")])
                  ])
                ])
              ])
            ])
          ],
          2
        )
      ]),
      _c(
        "div",
        { staticClass: "right_user" },
        [
          _c("bannerList", {
            attrs: { authDialog: _vm.authDialog },
            on: {
              "update:authDialog": function($event) {
                _vm.authDialog = $event
              },
              "update:auth-dialog": function($event) {
                _vm.authDialog = $event
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "launch_contract_box" }, [
      _c("div", { staticClass: "launch_img" }, [
        _c("div", { staticClass: "add_btn" }, [
          _c("img", {
            staticClass: "add_img",
            attrs: {
              src: require("../../static/images/home/add_red.png"),
              alt: ""
            }
          }),
          _c("img", {
            staticClass: "hover_add_img",
            attrs: { src: require("../../static/images/home/add.png"), alt: "" }
          }),
          _c("span", [_vm._v("发起签署")])
        ]),
        _c("p", { staticClass: "add_p" }, [
          _vm._v("\n              支持\n              "),
          _c("span", { staticClass: "add_span" }, [_vm._v("上传文件")]),
          _vm._v("及\n              "),
          _c("span", { staticClass: "add_span" }, [_vm._v("使用模板")]),
          _vm._v("发起签署\n            ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _c("img", {
        staticClass: "lament_img",
        attrs: {
          src: require("../../static/images/home/lament_img.png"),
          alt: ""
        }
      }),
      _c("span", [_vm._v("当前尚未加入/创建企业")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "join_card" }, [
      _c("img", {
        staticClass: "no_join",
        attrs: { src: require("../../static/images/home/no_join.png"), alt: "" }
      }),
      _c("div", { staticClass: "join_content" }, [
        _c("p", { staticClass: "join_title" }, [_vm._v("当前还未加入企业")]),
        _c("p", { staticClass: "join_grey" }, [
          _vm._v("加入企业可代表企业签署及管理合同")
        ]),
        _c("div", { staticClass: "join_btn" }, [
          _c("div", { staticClass: "btn_one" }, [_vm._v("加入企业")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "li_content" }, [
      _c("div", { staticClass: "bottom" }, [
        _c("img", { attrs: { src: "/images/web/join.png" } }),
        _c("p", [
          _vm._v(
            "\n                    该企业邀请您成为企业成员，\n                    "
          ),
          _c("a", { staticClass: "com-link" }, [_vm._v("立即加入>>")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img_box" }, [
      _c("img", {
        staticClass: "li_img",
        attrs: {
          src: require("../../static/images/home/signed_img.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img_box" }, [
      _c("img", {
        staticClass: "li_img",
        attrs: {
          src: require("../../static/images/home/approve_img.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img_box" }, [
      _c("img", {
        staticClass: "li_img",
        attrs: { src: require("../../static/images/home/end_img.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "li_content" }, [
      _c("div", { staticClass: "li_once" }, [
        _c("div", { staticClass: "img_box" }, [
          _c("img", {
            staticClass: "li_img",
            attrs: {
              src: require("../../static/images/home/signed_img.png"),
              alt: ""
            }
          })
        ]),
        _c("div", { staticClass: "li_text" }, [
          _c("p", { staticClass: "p" }, [_vm._v("--")]),
          _c("span", [_vm._v("待签署")])
        ])
      ]),
      _c("div", { staticClass: "li_once" }, [
        _c("div", { staticClass: "img_box" }, [
          _c("img", {
            staticClass: "li_img",
            attrs: {
              src: require("../../static/images/home/approve_img.png"),
              alt: ""
            }
          })
        ]),
        _c("div", { staticClass: "li_text" }, [
          _c("p", { staticClass: "p" }, [_vm._v("--")]),
          _c("span", [_vm._v("待审批")])
        ])
      ]),
      _c("div", { staticClass: "li_once" }, [
        _c("div", { staticClass: "img_box" }, [
          _c("img", {
            staticClass: "li_img",
            attrs: {
              src: require("../../static/images/home/end_img.png"),
              alt: ""
            }
          })
        ]),
        _c("div", { staticClass: "li_text" }, [
          _c("p", { staticClass: "p" }, [_vm._v("--")]),
          _c("span", [_vm._v("已结束")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img_box" }, [
      _c("img", {
        staticClass: "li_img",
        attrs: {
          src: require("../../static/images/home/signed_img.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img_box" }, [
      _c("img", {
        staticClass: "li_img",
        attrs: { src: require("../../static/images/home/end_img.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4612fa92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4612fa92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/login/dingMiddle.vue
// module id = Zsdu
// module chunks = 87